export default __webpack_public_path__ + "static/media/coin.2a701df4.png";